module.exports = __webpack_public_path__ + "img/sdk3.e8bd78de.png";